import {
  DefaultButton,
  DirectionalHint,
  PrimaryButton,
  TooltipDelay,
  TooltipHost,
} from "@fluentui/react";
import React, { useContext, useState } from "react";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import { loadOutline } from "../../../helpers/CornerstoneViewportService";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import OutlineIcon from "../../../../../components/SVGComponents/OutlineIcon";
import { toolTipStyles } from "../../../styles/styles";
import { SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST } from "../../../../../constants/Constants";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";

const defaultButtonStyles = {
  root: {
    height: "26px",
    width: "72px",
    marginLeft: "10px",
    borderRadius: "20px 0px 0px 20px",
  },
  rootHovered: {
    backgroundColor: "black",
  },
  rootPressed: {
    backgroundColor: "black",
  },
};

const primaryButtonStyles = {
  root: {
    height: "26px",
    width: "72px",
    marginLeft: "10px",
    borderRadius: "20px 0px 0px 20px",
  },
  rootHovered: {
    color: "white",
  },
  rootPressed: {
    color: "white",
  },
};

const OutlineButton = ({ outlineData, priors }) => {
  const { activeThumbnailIndex } = useContext(ThumbnailContext);
  const { 
    setIsOutlineEnabled,
    isOutlineEnabled, } =
    useContext(studyviewerContext);
  const {
    activeViewportIndex,
    originalImageActiveState,
    viewportSeriesData,
  } = useContext(ViewportContext);

  const handleClick = async () => {
    viewportSeriesData.map(async (data, index) => {
      if (SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST.includes(data?.modality?.trim?.()?.toUpperCase?.())) {
        await loadOutline(
          viewportSeriesData[index]?.outlineStack?.imageIds,
          isOutlineEnabled,
          index
        );
      }
    });
  };

  // useEffect(() => {
  //   console.log(outlineData);
  // });

  if (
    viewportSeriesData[activeViewportIndex]?.outlineStack?.imageIds[0] == null ||
    viewportSeriesData[activeViewportIndex]?.outlineStack?.imageIds[0] == "" ||
    originalImageActiveState[activeViewportIndex]
  ) {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={"outline"}
          directionalHint={DirectionalHint.bottomLeftEdge}
          styles={toolTipStyles}
          content={"Outline"}
        >
          <span style={{ cursor: "not-allowed", display:"flex" }}>
            <OutlineIcon active={false} />
          </span>
        </CustomToolTipHost>
      </>
    );
  } else {
    return (
      <>
        <CustomToolTipHost
          delay={TooltipDelay.zero}
          id={"outline"}
          directionalHint={DirectionalHint.bottomLeftEdge}
          styles={toolTipStyles}
          content={"Outline"}
        >
          <span style={{display:"flex"}} onClick={() => setIsOutlineEnabled(!isOutlineEnabled)}>
            <OutlineIcon active={isOutlineEnabled} />
          </span>
        </CustomToolTipHost>
      </>
    );
  }
  // return <></>
};

export default OutlineButton;
